import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import api from "../../utils/api";

const GeoBreakdownChart = ({ queryParams }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/api/analytics/geo?level=country&${queryParams}`)
      .then((res) => setData(res.data.slice(0, 15)))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status" />
      </div>
    );
  }

  if (data.length === 0) {
    return <p className="text-muted text-center">No data</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis dataKey="location" type="category" width={40} tick={{ fontSize: 12 }} />
        <Tooltip />
        <Bar dataKey="clicks" fill="#198754" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GeoBreakdownChart;
